export default __webpack_public_path__ + "assets/icons/iconNotSupport.775f88cb.svg";